export const common = {
  // Navbar
  nav: {
    home: 'Inicio',
    why: 'Por qué',
    applications: 'Aplicaciones',
    products: 'Productos',
    resources: 'Recursos',
    contacts: 'Contactos',
    askAI: 'Preguntar a IA',
    myths: 'Mitos vs Hechos',
    o3101: 'O₃ 101',
    safety: 'Seguridad',
    faq: 'FAQ',
    blog: 'Blog',
  },
  
  // Hero
  hero: {
    badge: 'Hub Educativo • Seguridad primero • Eco-tech',
    titleA: 'OzoneFusion 2.0 — El ozono explicado bien. Usado mejor.',
    titleB: 'Seguridad, claridad, tecnología. Bienvenido al hub del ozono.',
    titleC: 'O₃ sin confusión: guías rápidas, FAQ, recursos y asistente IA.',
    subtitle: 'Conocer el ozono. Usarlo con seguridad.',
    cta1: 'Descubre O₃ 101',
    cta2: 'Guía de Seguridad',
  },
  
  // Why Section
  why: {
    title: 'Por qué un hub educativo',
    subtitle: 'Información clara, seguridad garantizada, sostenibilidad en el centro',
    clarity: {
      title: 'Claridad',
      description: 'Información científica accesible para todos, sin tecnicismos innecesarios.',
    },
    safety: {
      title: 'Seguridad',
      description: 'Protocolos verificados y directrices para un uso responsable del ozono.',
    },
    sustainability: {
      title: 'Sostenibilidad',
      description: 'Tecnología ecológica que respeta el medio ambiente y la salud.',
    },
  },
  
  // Myths vs Facts
  myths: {
    title: 'Mitos vs Hechos',
    subtitle: 'Desmintiendo conceptos erróneos sobre el ozono',
    myth1: 'Siempre es peligroso',
    fact1: 'Depende de la dosis, tiempo, ventilación y procedimientos',
    myth2: 'Es magia',
    fact2: 'Es química: potente cuando se gestiona correctamente',
    myth3: 'Daña todo',
    fact3: 'Compatible con la mayoría de materiales cuando se usa bien',
    myth4: 'No hace falta ventilar',
    fact4: 'La ventilación es fundamental para la seguridad',
  },
  
  // Safety
  safety: {
    title: 'La seguridad primero',
    subtitle: 'Las 6 reglas de oro para un uso responsable',
    rule1: {
      title: 'Ventilación',
      description: 'Ventila siempre los espacios después del tratamiento',
    },
    rule2: {
      title: 'Tiempos correctos',
      description: 'Respeta los tiempos de exposición recomendados',
    },
    rule3: {
      title: 'Concentraciones',
      description: 'Usa las dosis apropiadas para cada aplicación',
    },
    rule4: {
      title: 'Niños y mascotas',
      description: 'Manténlos alejados durante y después del tratamiento',
    },
    rule5: {
      title: 'Materiales compatibles',
      description: 'Verifica la compatibilidad con goma y plásticos',
    },
    rule6: {
      title: 'Mantenimiento',
      description: 'Inspecciona regularmente tu dispositivo',
    },
  },
  
  // Applications
  applications: {
    title: 'Aplicaciones del ozono',
    subtitle: 'Soluciones para cada necesidad',
    tabHome: 'Casa',
    tabB2B: 'B2B',
    home: {
      title: 'Para tu hogar',
      description: 'Sanitización natural para ambientes domésticos',
    },
    hotel: {
      title: 'Hotel & Hospitalidad',
      description: 'Higiene profesional para habitaciones y áreas comunes',
    },
    laundry: {
      title: 'Lavanderías',
      description: 'Lavado ecológico y eficaz',
    },
    b2b: {
      title: 'Soluciones B2B',
      description: 'Tecnología para empresas y profesionales',
    },
    discoverProducts: 'Descubre los productos',
  },
  
  // Products
  products: {
    title: 'Nuestros productos',
    subtitle: 'Tecnología certificada para cada necesidad',
    cta: 'Saber más',
  },
  
  // Resources
  resources: {
    title: 'Recursos gratuitos',
    subtitle: 'Descarga guías, listas de verificación y materiales educativos para un uso seguro del ozono',
    checklist: {
      title: 'Lista de Seguridad',
      description: 'Lista completa de controles a realizar antes, durante y después de cada tratamiento.',
      cta: 'Descargar PDF',
    },
    guide: {
      title: 'Guía Rápida O₃',
      description: 'Manual práctico con todo lo que necesitas saber para empezar con seguridad.',
      cta: 'Descargar PDF',
    },
    poster: {
      title: 'Póster Informativo',
      description: 'Póster A4 para imprimir con las reglas de oro para un uso seguro del ozono.',
      cta: 'Descargar PDF',
    },
  },
  
  // Blog
  blog: {
    title: 'Educación & Seguridad',
    subtitle: 'Artículos, guías y análisis sobre el ozono',
    comingSoon: 'Contenido próximamente',
    comingSoonDesc: '¡Estamos preparando artículos y guías detalladas para ti. Vuelve pronto!',
    cta: 'Suscribirse al boletín',
  },
  
  // AI Assistant
  ai: {
    badge: 'Asistente de IA Avanzado',
    title: 'Tu Coach de Seguridad O₃',
    titleHighlight: 'Coach de Seguridad',
    subtitle: 'Un asistente inteligente siempre a tu lado para responder a cualquier pregunta sobre el ozono, la seguridad de uso y las mejores prácticas. Chat o voz, cuando quieras.',
    features: {
      friendly: {
        title: 'Amigable y Claro',
        description: 'Respuestas sencillas y comprensibles, sin tecnicismos innecesarios',
      },
      responsible: {
        title: 'Responsable',
        description: 'Barreras de seguridad: sin promesas médicas, solo información validada',
      },
      knowledge: {
        title: 'Base de Conocimientos',
        description: 'Acceso a todas las guías, preguntas frecuentes y listas de verificación del sitio',
      },
      available: {
        title: 'Siempre Disponible',
        description: 'Chat y voz, 24/7, para responder a tus preguntas',
      },
    },
    ctaCard: {
      title: '¿Listo para hacer preguntas?',
      description: 'Haz clic en el botón turquesa de la parte inferior derecha para iniciar una conversación. Puedes escribir o hablar directamente con el Coach.',
      cta: 'Abrir Coach de IA',
    },
    examplesTitle: 'O prueba con una de estas preguntas:',
    question1: '¿Cómo funciona el ozono?',
    question2: '¿Es seguro para mi hogar?',
    question3: '¿Cuánto tiempo debo ventilar?',
    question4: '¿Puedo usarlo con mascotas?',
    question5: '¿Qué concentraciones son seguras?',
    question6: '¿Cómo desinfectar tejidos?',
    safetyNotice: {
      title: 'Nota importante sobre seguridad',
      description: 'El Coach de IA proporciona información educativa basada en estándares e investigaciones científicas. No ofrece asesoramiento médico o terapéutico. Para preguntas clínicas o de salud, consulta siempre a un profesional cualificado. El Coach te guiará hacia los recursos adecuados.',
    },
  },
  
  // About
  about: {
    title: 'Quiénes somos',
    subtitle: 'Purevital / OzoneFusion',
    mission: 'Nuestra misión',
    missionText: 'Hacer que la tecnología del ozono sea accesible, segura y comprensible para todos. Creemos en un futuro más limpio a través de la educación y la innovación responsable.',
    values: 'Nuestros valores',
    value1: 'Transparencia científica',
    value2: 'Seguridad primero',
    value3: 'Sostenibilidad ambiental',
    value4: 'Innovación responsable',
  },
  
  // Contact
  contact: {
    title: 'Contáctanos',
    subtitle: 'Estamos aquí para responder tus preguntas',
    name: 'Nombre',
    email: 'Email',
    phone: 'Teléfono',
    message: 'Mensaje',
    send: 'Enviar mensaje',
    whatsapp: 'Escríbenos en WhatsApp',
    emailUs: 'Envíanos un email',
    newsletter: 'Suscribirse al boletín',
    newsletterDesc: 'Recibe actualizaciones, guías y consejos de seguridad',
    subscribe: 'Suscribirse',
    success: '¡Mensaje enviado con éxito!',
    error: 'Error al enviar. Inténtalo de nuevo.',
  },
  
  // Footer
  footer: {
    tagline: 'Educación, seguridad y tecnología para un futuro más limpio',
    explore: 'Explorar',
    education: 'Educación',
    company: 'Empresa',
    support: 'Soporte',
    legal: 'Legal',
    contactUs: 'Contáctanos',
    faq: 'FAQ',
    guides: 'Seguridad y Directrices',
    community: 'Comunidad',
    privacy: 'Política de Privacidad',
    cookies: 'Política de Cookies',
    disclaimer: 'Descargo de responsabilidad',
    terms: 'Términos y Condiciones',
    allProducts: 'Todos los Productos',
    compareProducts: 'Comparar Productos',
    rights: 'Todos los derechos reservados',
    poweredBy: 'Powered by Readdy',
  },
  
  // Common
  common: {
    readMore: 'Leer más',
    learnMore: 'Saber más',
    download: 'Descargar',
    close: 'Cerrar',
    back: 'Atrás',
    next: 'Siguiente',
    loading: 'Cargando...',
  },
};
